'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components2 = require('components');

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _pacomo = require('utils/pacomo');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavMarkers = function NavMarkers(props) {
    var reqSetCode = props.reqSetCode,
        passengerId = props.passengerId,
        requirementSets = props.requirementSets;


    var dots = requirementSets.map(function (reqSet, i) {
        var code = reqSet.code;
        return _react2.default.createElement(
            'div',
            {
                key: i,
                className: (0, _classnames2.default)('dot', {
                    'selected': reqSetCode === code
                }),
                'data-tip': true, 'data-for': 'navmarker-tooltip-' + code
            },
            _react2.default.createElement(
                _reactRouter.Link,
                { to: '/' + passengerId + '/' + code + ' ', 'aria-label': 'Requirement set ' + code },
                _react2.default.createElement(_components2.IconMarker, null)
            ),
            _react2.default.createElement(
                _reactTooltip2.default,
                { id: 'navmarker-tooltip-' + code, type: 'dark', place: 'top' },
                _react2.default.createElement(_components2.TranslatedRequirementSetTitle, { requirementSet: reqSet })
            )
        );
    });

    return _react2.default.createElement(
        'div',
        null,
        dots
    );
};

exports.default = (0, _pacomo.pacomoTransformer)(NavMarkers);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/RequirementSet/NavMarkers.js
// module id = 1315
// module chunks = 0